<template>
  <GModal v-show="isBrowseByBrand" ref="modalFilterBrand" class="modal--full-fixed modal--filter-by-brand">
    <div slot="header">
      <button type="button" class="close" aria-label="Close" style="right: inherit !important">
        <img src="/assets/img/arrow_left.svg" alt="SOCO" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading">Browse By Brand</h2>
    </div>
    <div slot="body" class="content">
      <div class="popular-brands">
        <div class="default-title">Featured Brand</div>
        <div class="list-popular-brands">
          <div v-for="(brand, idx) in featuredBrands" :key="idx" class="item">
            <router-link
              :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
              @click.native="closeModal"
            >
              <img
                v-if="brand.logo"
                :src="mainImage(brand.logo)"
                :alt="brand.name"
                class="brand-logo"
                @error="brandImageErrorHandler($event)"
              />
              <img v-else src="/assets/img/dummy_product.svg" class="brand-logo error-brand" alt="no image" />
            </router-link>
          </div>
        </div>
      </div>
      <div class="mega-menu-wrapper">
        <div class="brands-menu-left">
          <ul class="tabs tabs-brand">
            <li :class="{ active: activeTab === 0 }">
              <a href="" title="Brand Name" @click.prevent="activeTab = 0">Brand Name</a>
            </li>
            <li :class="{ active: activeTab === 1 }">
              <a href="" title="Brand Origins" @click.prevent="activeTab = 1">Brand Origin</a>
            </li>
          </ul>
          <div class="search">
            <input
              v-model="keyword"
              type="text"
              name="search"
              autocomplete="off"
              placeholder="Search Brand..."
              class="input-search"
              @keyup="searchQuery"
            />
            <span class="icon-search"></span>
          </div>
          <template v-if="$SO.size(dynamicDataBrands)">
            <div class="search-by-alpha">
              <a
                v-for="(value, key) in dynamicDataBrands"
                :key="key"
                href="#brand-letter-A"
                class="brand-tag"
                :class="[{ active: selectedLetter === key }, { disabled: !value.length }]"
                @click.prevent="toLetter(key)"
                >{{ key }}</a
              >
            </div>
            <div id="brand-value" class="brand-value">
              <!-- tempalte for brand alphabet -->
              <template v-if="activeTab === 0">
                <div class="brand-val-list">
                  <template v-for="(value, key) in dynamicDataBrands">
                    <template v-if="value.length">
                      <h4 :id="'brand-letter-' + key" :key="'brand-letter-' + key" class="">
                        {{ key }}
                      </h4>
                      <ul :key="'brand-letter--' + key">
                        <li v-for="brand in value" :key="brand._id">
                          <router-link
                            :to="`/brand/${brand.my_soco_sql_id}/${$options.filters.slug(brand.name)}`"
                            @click.native="closeModal"
                          >
                            <!-- <template v-if="brand.logo">
                                    <img
                                    :src="mainImage(brand.logo)"
                                    onerror="this.src='/assets/img/default_img_brand.svg'"
                                    :alt="brand.name"
                                    >
                                </template>
                                <template v-else>
                                    <img src="/assets/img/default_img_brand.svg" alt="SOCO">
                                </template> -->
                            {{ brand.name }}
                          </router-link>
                        </li>
                      </ul>
                    </template>
                  </template>
                  <!-- <template v-else>
                    <ul>
                      <li>
                        <span>No Brands</span>
                      </li>
                    </ul>
                  </template> -->
                </div>
              </template>
              <!-- template for brand origin -->
              <template v-else>
                <div class="brand-val-list__origin">
                  <template v-for="(value, key) in dynamicDataBrands">
                    <template v-if="value.length">
                      <h4 :id="'brand-letter-' + key" :key="'brand-letter-' + key" class="">
                        {{ key }}
                      </h4>
                      <ul :key="'brand-letter--' + key">
                        <li v-for="brand in value" :key="brand._id">
                          <router-link
                            :to="`/brand/${brand.country_tag_id}-${$options.filters.slug(brand.country)}`"
                            @click.native="closeModal"
                          >
                            <img v-if="brand.flag" :src="brand.flag" :alt="brand.country" class="img_country" />
                            {{ brand.country }}
                          </router-link>
                        </li>
                      </ul>
                    </template>
                  </template>
                  <!-- <template v-else>
                    <h4 class="" :id="'brand-letter-'+ key" :key="'brand-letter-'+ key">{{key}}</h4>
                    <ul>
                        <li>
                            <span>No Brands</span>
                        </li>
                    </ul>
                  </template> -->
                </div>
              </template>
            </div>
          </template>
          <div v-else class="gfmp-brand-value">
            <div style="margin-top: 15px"></div>
            <GFMP
              v-for="i in 2"
              :key="`brand-value-${i}`"
              :styles="{
                minHeight: '136px',
                width: '100%',
                marginBottom: '14px',
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
export default {
  name: 'browse-by-brands-mobile',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      filterBrands: '',
      reviewedBrands: [],
      keyword: '',
      selectedLetter: '',
      isLoadingFinishMostReviewBrand: false,
      activeTab: 0,
    };
  },
  computed: {
    featuredBrands() {
      return this.$store.state.featuredBrands;
    },
    isBrowseByBrand() {
      return this.$store.state.filterProduct.browseBy.brand;
    },
    allBrands: {
      get() {
        return this.$store.state.brands;
      },
      set(data) {
        this.$store.commit('setDataBrands', data);
      },
    },
    allOriginBrands: {
      get() {
        return this.$store.state.brands_origin;
      },
      set(data) {
        this.$store.commit('setDataBrandsOrigin', data);
      },
    },
    dynamicDataBrands() {
      if (this.activeTab === 0) {
        return this.$SO.size(this.filterBrands) ? this.filterBrands : this.allBrands;
      } else {
        return this.$SO.size(this.filterBrands) ? this.filterBrands : this.allOriginBrands;
      }
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
  },
  created() {
    if (!this.$SO.size(this.dynamicDataBrands)) {
      this.$store.dispatch('getBrands');
      this.$store.dispatch('getBrandsOrigin');
    }
    this.getMostReviewsBrands();
  },
  methods: {
    applyFilter() {
      const value = this.$SO.size(this.filterBrands) ? this.filterBrands : '';
      this.$emit('applyFilter', value);
      this.closeModal();
    },
    buildStyle() {
      const windowHeight = window.innerHeight;
      const modalHeaderHeight = 47;
      const maxContentHeight = windowHeight - modalHeaderHeight;

      this.$refs.modalBodyFilterBrand.style.height = maxContentHeight + 'px';
      this.$refs.modalBodyFilterBrand.style.maxHeight = maxContentHeight + 'px';
    },
    closeModal() {
      this.$store.commit('setBrowseBy', {
        type: 'brand',
        value: false,
      });
    },
    searching() {
      this.$emit('searching', this.searchText);
    },
    toLetter(letter) {
      this.selectedLetter = letter;
      const topPos = document.getElementById('brand-letter-' + letter).offsetTop;
      const containerOffset = document.getElementById('brand-value').offsetTop;
      document.getElementById('brand-value').scrollTop = topPos - containerOffset;
    },
    getMostReviewsBrands() {
      this.isLoadingFinishMostReviewBrand = false;
      let loadedBrandsHash = [];
      let featuredBrands = [];
      let defaultBrands = [];
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/brands', {
          params: {
            fields: 'my_soco_sql_id name logo featured_position',
            filter: {
              is_featured: true,
            },
            sort: '-featured_created_at',
            limit: 10,
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data.data) {
            featuredBrands = res.data.data;
            this.$store.commit('setFeaturedBrands', res.data.data);
            loadedBrandsHash = loadedBrandsHash.concat(featuredBrands.map((it) => it._id));
          }
        })
        .then(() => {
          if (loadedBrandsHash.length < 10) {
            return this.$MS_SOCO_PUBLIC_API_URL
              .get('/brands', {
                params: {
                  fields: 'my_soco_sql_id name logo',
                  section: 'most-reviewed-brand',
                  filter: {
                    _id: { $nin: loadedBrandsHash },
                  },
                  sort: '-total_reviews',
                  limit: 10 - loadedBrandsHash.length,
                },
              })
              .then((response) => {
                if (response.status === 200 && response.data.data) {
                  defaultBrands = response.data.data;
                }
              });
          } else {
            return;
          }
        })
        .then(() => {
          const brands = [];
          const maxLength = 10;
          let position = 0;
          let featuredPosition = 0;
          let defaultPosition = 0;

          while (position < maxLength) {
            if (featuredBrands[featuredPosition] && featuredBrands[featuredPosition].featured_position == position) {
              brands.push({
                ...featuredBrands[featuredPosition],
                featured_position: position,
              });
              featuredPosition++;
            } else if (defaultBrands[defaultPosition]) {
              brands.push({
                ...defaultBrands[defaultPosition],
                featured_position: position,
              });
              defaultPosition++;
            }
            position++;
          }

          this.$store.commit('setReviewedBrands', brands);
          this.isLoadingFinishMostReviewBrand = true;
        })
        .catch((err) => {
          this.isLoadingFinishMostReviewBrand = true;
        });
    },
    searchQuery(e) {
      if (this.keyword) {
        const searchResult = {};
        Object.keys(this.allBrands).map((alphabet) => {
          this.allBrands[alphabet].forEach((brand) => {
            if (brand.name.toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0) {
              if (!searchResult[brand.name[0].toUpperCase()]) {
                searchResult[brand.name[0].toUpperCase()] = [];
              }
              searchResult[brand.name[0].toUpperCase()].push(brand);
            }
          });
        });
        this.filterBrands = searchResult;
      } else {
        this.filterBrands = '';
      }
    },
    selectBrand() {
      this.closeModal();
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.isDesktop ? 'w=50' : 'w=74',
        image: src,
      });
    },
    brandImageErrorHandler(e) {
      e.target.src = '/assets/img/dummy_product.svg';
    },
  },
};
</script>
<style lang="scss" scoped>
.popular-brands {
  display: block;
  background: #ffffff;
  width: 100%;
  .default-title {
    padding: 16px 0 6px;
    margin: 0 0 0 16px;
    font-family: 'lato-bold', sans-serif;
    font-size: 16px;
    line-height: 22px;
  }
  .list-popular-brands {
    display: flex;
    justify-content: flex-start;
    padding: 0 0 0 16px;
    margin-top: 5px;
    margin-bottom: 8px;
    overflow-y: hidden;
    overflow-x: auto;
    .item {
      border: 1px solid #e5e5e5;
      border-radius: 4px;
      height: 50px;
      width: auto;
      min-width: calc(25% + 16px);
      margin: 0 12px 0 0;
      text-align: center;
      img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
  }
}
.mega-menu-wrapper {
  .brands-menu-left {
    .tabs-brand {
      margin: 9px 0 20px;
      display: flex;
      li {
        border-bottom: 3px solid #e5e5e5;
        width: 100%;
        text-align: center;
        padding: 15px 0 14px;
        a {
          font: 14px/17px 'lato-bold', sans-serif;
          color: #8c8582;
          padding: 0px 20px;
        }
        &.active {
          border-bottom: 3px solid #DA2A52;
          a {
            color: #231f20;
          }
        }
      }
    }
    .search {
      width: 100%;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      padding: 10px;
      input.input-search {
        background: #fff;
        border: 1px solid #e5e5e5;
        font: 14px/17px Lato-Regular, sans-serif;
        color: #231f20;
        width: 100%;
        height: 40px;
        padding: 12px 12px 11px 34px;
        -o-border-radius: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        &:focus {
          border: 1px solid #e5e5e5 !important;
          background: #fff;
        }
      }
      .icon-search {
        position: absolute;
        cursor: pointer;
        z-index: 1;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 55px;
        &:before {
          background: transparent url('~/assets/img/search-icon.svg') no-repeat 50%;
          -webkit-background-size: 18px 18px;
          -moz-background-size: 18px 18px;
          -o-background-size: 18px 18px;
          background-size: 18px 18px;
          content: '';
          width: 24px;
          height: 24px;
          display: flex;
        }
      }
    }
    .search-by-alpha {
      position: relative;
      overflow: scroll;
      width: 100%;
      border-bottom: 1px solid #e5e5e5;
      padding: 8px 4px;
      overflow: auto;
      white-space: nowrap;
      .brand-tag {
        text-align: center;
        font: 14px 'lato-regular', sans-serif;
        color: #020202;
        line-height: 25px;
        display: inline-block;
        text-transform: uppercase;
        height: 25px;
        width: 29px;
        border-radius: 100px;
        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
      a.active {
        color: #fff;
        background: #DA2A52;
      }
      a.disabled {
        color: #e5e5e5;
        pointer-events: none;
        touch-action: none;
      }
      .brand-show-all {
        display: inline-block;
        color: #b32656;
        letter-spacing: 0;
        font-size: 14px;
        line-height: 14px;
        font-family: 'lato-medium', sans-serif;
        float: right;
        margin-top: 3px;
        img {
          display: inline-block;
          margin-left: 5px;
          vertical-align: inherit;
        }
      }
    }
    .brand-value {
      height: calc(100vh - 200px);
      overflow-y: scroll;
      .brand-val-list {
        &__origin {
          h4 {
            font: 14px/20px 'lato-bold', sans-serif;
            color: #b02a56;
            margin: 0px;
            text-transform: uppercase;
            padding: 10px;
            border-bottom: 1px solid #e5e5e5;
          }
          ul {
            width: 100%;
            float: inherit;
            margin: 0;
            &:last-child {
              padding-bottom: 20px;
            }
            li {
              list-style: none;
              display: block;
              width: 100%;
              padding: 10px;
              border-bottom: 1px solid #e5e5e5;
              a:link,
              a:visited {
                img {
                  height: 14px;
                  width: 20px;
                  margin-right: 16px;
                  object-fit: contain;
                  object-position: left;
                }
                font: 13px 'lato-regular', sans-serif !important;
                color: #231f20 !important;
                letter-spacing: 1.5px !important;
                text-transform: uppercase !important;
                line-height: 20px;
                width: 100%;
                text-align: left;
                display: block;
              }
            }
          }
        }
        h4 {
          font: 14px/20px 'lato-bold', sans-serif;
          color: #b02a56;
          margin: 0px;
          text-transform: uppercase;
          padding: 10px;
          border-bottom: 1px solid #e5e5e5;
        }
        ul {
          width: 100%;
          float: inherit;
          margin: 0;
          &:last-child {
            padding-bottom: 20px;
          }
          li {
            list-style: none;
            display: block;
            width: 100%;
            padding: 10px;
            border-bottom: 1px solid #e5e5e5;
            a:link,
            a:visited {
              img {
                height: 22px;
                width: 40px;
                margin-right: 20px;
                object-fit: contain;
                object-position: left;
              }
              font: 14px Lato-Regular, sans-serif;
              color: #231f20;
              line-height: 20px;
              width: 100%;
              text-align: left;
              display: block;
              margin: 0px;
              padding: 0px;
              text-transform: inherit;
              letter-spacing: 0px;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .modal--full-fixed .modal-heading {
    font: 16px/15px 'lato-bold', sans-serif;
    color: #231f20;
    padding: 1px 0;
    margin: 0 0 0 30px;
    // text-transform: uppercase;
    text-align: left;
  }
  .modal--full-fixed .modal-header .close {
    margin-top: -5px;
    right: inherit !important;
    left: 17px !important;
  }
  .brand-val-list ul li a img {
    display: none;
  }
  .brand-val-list ul li a {
    font: 13px 'lato-regular', sans-serif !important;
    color: #231f20 !important;
    letter-spacing: 1.5px !important;
    text-transform: uppercase !important;
  }
  h4 {
    color: #231f20 !important;
    letter-spacing: 2px !important;
    font: 13px/20px 'lato-bold', sans-serif !important;
  }
  .mega-menu-wrapper .brands-menu-left .search-by-alpha .brand-tag {
    color: #231f20;
    letter-spacing: 2px;
  }
}
</style>
